export default __webpack_public_path__ + "static/media/ongoingIcon.082eeb4c.svg";